import { FloorCompleteFragment } from "entities/floors/graphql/fragments.generated"
import { useFloorFragment } from "entities/floors/model/useFloorFragment"
import { useProductPositionFragment } from "entities/product-positions/api/useProductPositionFragment"
import { ProductPositionFragment } from "entities/product-positions/graphql/fragments.generated"
import { RoomCompleteFragment } from "entities/rooms/graphql/fragments.generated"
import { useRoomFragment } from "entities/rooms/model/useRoomFragment"

/**
 * Attempts to read a Floor, Room, or ProductPosition fragment from Apollo cache reactively.
 * Tries each type in order and returns the first one found.
 *
 * This is the React hook equivalent of `readProjectChildFragment`.
 *
 * @param id - The ID of the child entity
 * @returns The child fragment (Floor, Room, or ProductPosition) or undefined if not found or incomplete
 */
export function useProjectChildFragment(
  id: string | null | undefined
):
  | FloorCompleteFragment
  | RoomCompleteFragment
  | ProductPositionFragment
  | undefined {
  // Call all fragment hooks unconditionally (React rules of hooks)
  const floor = useFloorFragment(id || "")
  const room = useRoomFragment(id || "")
  const productPosition = useProductPositionFragment(id)

  // Return first one with data (nullish coalescing)
  return floor ?? room ?? productPosition
}
